import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4k86pqgc3: FaireProductEntity = {
  token: "p_t4k86pqgc3",
  type: "product",
  name: "Sunburst Heart Charm",
  brandToken: "b_859446c0",
  brandName: "Jessica Matrasko Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/026b1502cb4424c8e42d44ff06d2c9cc9b587f9a48ebe531087007cda0c800e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1515a77fc2b1ce80222e0330c34c0739e5815261397eb1c72d5b3dbf201c848e.jpeg",
  ],
  priceDollars: 15.16,
  description:
    'Gold filled vintage inspired sunburst heart charm for charm necklaces and bracelets. Attaches with a spring ring clasp to a variety of chain styles, No tools needed! ( I recommend our Kylie or Marla chains!)\n-Gold filled. \n-Total charm length 1". ',
  tags: [],
  msrpDollars: 30.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:26.778Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
